export const fetchApi = async (url,{
        method = "POST",
        body = null,
        headers = {},
    } = {}
) => {
    try {
        const token = localStorage.getItem("token");

        const response = await fetch(url, {
            method,
            headers: {
                ...(body && {
                    "Content-Type": "application/json",
                }),

                ...(token && {
                    Authorization: `Bearer ${token}`,
                }),

                ...headers,
            },

            ...(body && {
                body: JSON.stringify(body),
            }),
        });

        if ([401, 403].includes(response.status) ) {
            localStorage.removeItem("token");
            window.location.href = "/";
            return;
        }

        return response;
    } catch (error) {
        throw error;
    }
};